import { useDispatch, useSelector } from 'react-redux';

import { streamActions, streamSelectors } from '../../../../store/modules/stream';
import { DEFAULT_PAGE_LIMIT } from '../../../../store/modules/stream/reducer/streamsListReducer';

const useStreamPaging = () => {
  const dispatch = useDispatch();

  const params = useSelector(streamSelectors.selectStreamsListParams)!;
  const listCount = useSelector(streamSelectors.selectFullStreamsList).length;

  const isPrevButtonVisible = params?.offset !== 0;
  const isNextButtonVisible = params?.limit && listCount > (params.limit - 1 || DEFAULT_PAGE_LIMIT);

  const handleNextPage = () => dispatch(streamActions.fetchStreamsNextPage());

  const handlePrevPage = () => dispatch(streamActions.fetchStreamsPrevPage());

  return [isPrevButtonVisible, isNextButtonVisible, handleNextPage, handlePrevPage] as const;
};

export default useStreamPaging;
